import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { runSingleAcquire } from "@/lib/acquire-actions";
import type { Machine } from "@/lib/types";

/** Per-row Acquire button — fires immediately, no confirmation dialog. */
export function AcquireButton({ machine }: { machine: Machine }) {
  const queryClient = useQueryClient();
  return (
    <Button
      size="sm"
      variant="outline"
      className="h-7 text-[12px] text-primary hover:bg-primary/10 hover:text-primary"
      onClick={() => runSingleAcquire(machine, queryClient)}
    >
      Acquire
    </Button>
  );
}
